import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getCartRequest,
  getproductwithbrandRequest,
  insertCartRequest,
} from "../../Containers/Home/Home-slice";
import { useParams } from "react-router";

import banner1 from "../../assests/banner1.jpg";
import banner2 from "../../assests/bannernew1.jpg";
import banner3 from "../../assests/bannernew4.jpg";
import ProductCard from "../Cards/Card";
import { FaHome, FaTags, FaBox, FaChevronRight } from "react-icons/fa";

import "../../Styles/Brandproduct.css";
import { FaTruck } from "react-icons/fa";
import { showSuccess } from "../../utils/Toast";
import { addwishlistrequest } from "../../Containers/Home/Home-slice";
import { DEFAULT_PRODUCT_IMAGE, withDefaultProductImage } from "../../utils/productPresentation";
import { getBuyerToken } from "../../utils/authStorage";
import { addGuestCartItem } from "../../utils/guestCart";

function Brandsproduct({
  getproductwithbrandRequest,
  productwithbrand,
  addcartdata,
  getCartRequest,
  insertCartRequest,
  addwishlistrequest,
  addwishlistdata,
}) {
  const { id } = useParams();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (id) getproductwithbrandRequest(id);
  }, [id]);

  useEffect(() => {
    if (addwishlistdata && addwishlistdata.success) {
      // getProductRequest();
      getproductwithbrandRequest(id);
      showSuccess("Wish List Added Successfully");
    }
  }, [addwishlistdata]);

  /* ---------- Banner ---------- */
  const banners = [banner3, banner1, banner2];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev === banners.length - 1 ? 0 : prev + 1));
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (addcartdata) {
      showSuccess(addcartdata.message);
      getCartRequest();
    }
  }, [addcartdata]);

  const prev = () => setCurrent((c) => (c === 0 ? banners.length - 1 : c - 1));
  const next = () => setCurrent((c) => (c === banners.length - 1 ? 0 : c + 1));

  /* ---------- Helpers ---------- */
  const getFirstImage = (imageUrl) => {
    if (!imageUrl) return DEFAULT_PRODUCT_IMAGE;
    try {
      if (imageUrl.startsWith("[")) {
        const arr = JSON.parse(imageUrl);
        return arr[0] || DEFAULT_PRODUCT_IMAGE;
      }
      return withDefaultProductImage(imageUrl);
    } catch {
      return withDefaultProductImage(imageUrl);
    }
  };

  const discountedPrice = (price, discount) =>
    discount ? price - (price * discount) / 100 : price;

  const onclickcart = (data) => {
    // console.log("data", data);
    // const token = localStorage.getItem("buyer_access_token");
    // if (!token) {
    //   this.setState({ setAuthModalOpen: true });
    //   return;
    // }

    const payload = {
      product_id: data?.id ?? data?.product_id, // number
      quantity: data?.quantity ? Number(data.quantity) : 1, // number
      price: Number(data?.price ?? 0), // number
      discount: Number(data?.discount ?? 0), // number
      attributes: data.attributes,
    };

    // console.log("Cannot add to cart: product_id missing", payload);
    if (!payload.product_id) {
      return;
    }
    // console.log("Adding to cart payload ->", payload);
    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      return;
    }

    insertCartRequest(payload);
  };

  const onclickaddwishlist = (data) => {
    // console.log("data", data);
    addwishlistrequest(data.id);
  };

  return (
    <>
   

      {/* ---------- Breadcrumb ---------- */}
      <div className="breadcrumb-navigation">
        <div className="breadcrumb-wrapper">
          <a href="/" className="breadcrumb-item">
            <FaHome className="breadcrumb-icon" />
            <span className="breadcrumb-text">Home</span>
          </a>

          <FaChevronRight className="breadcrumb-arrow" />

          <a href="/brands" className="breadcrumb-item">
            <FaTags className="breadcrumb-icon" />
            <span className="breadcrumb-text">Brands</span>
          </a>

          <FaChevronRight className="breadcrumb-arrow" />

          <div className="breadcrumb-item active">
            <FaBox className="breadcrumb-icon" />
            <span className="breadcrumb-text">Products</span>
          </div>
        </div>
      </div>

      {/* ---------- Products Grid ---------- */}
      <div className="brands-products-container">
        <div className="brands-products-grid">
          {productwithbrand?.map((p) => {
            // console.log("productwithbrand", productwithbrand);
            const img = getFirstImage(p.image_url);
            const imgUrl = !img
              ? DEFAULT_PRODUCT_IMAGE
              : /^https?:\/\//i.test(img) || img.startsWith("/")
                ? img
                : `https://neeuro-ai.s3.ap-south-1.amazonaws.com/${img}`;

            return (
              // <div key={product.id} className="amazon-card">
              //   {/* Image */}
              //   <div className="amazon-image">
              //     <img src={imgUrl} alt={product.name} />
              //   </div>
              //   {/* <div className="amazon-delivery">
              //     <FaTruck />
              //     <span>Fastest by 10th Jan</span>
              //   </div> */}
              //   <div className="amazon-title">{product.name}</div>
              //   <div className="amazon-price">
              //     <span className="price-final">
              //       AED &nbsp;
              //       {Math.round(
              //         discountedPrice(product.price, product.discount)
              //       )}
              //     </span>
              //     {product.discount > 0 && (
              //       <span className="price-original">
              //         AED{Math.round(product.price)}
              //       </span>
              //     )}
              //   </div>

              //   {/* Button */}
              //   <button className="amazon-cart-btn">Add to cart</button>
              // </div>
              <ProductCard
                key={p.id}
                id={p.id}
                title={p.name}
                imageUrl={imgUrl}
                price={p.price}
                oldPrice={p.oldPrice}
                discount={p.discount}
                tagText={null}
                description={p.description}
                onAdd={() => onclickcart(p)}
                // category_id={p.category_id ?? cat.id}
                company_id={p.company_id}
                featured={p.featured}
                status={p.status}
                stock_quantity={p.stock_quantity}
                item={p}
                // catname={cat.name}
                onclickaddwishlist={() => onclickaddwishlist(p)}
                is_wishlist={p.is_wishlisted}
                // removewishlistrequest={removewishlistrequest}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  // console.log('addcartdata',state.Home.Cartdata)
  return {
    productwithbrand: state.Home?.getproductwithbranddata?.products || [],
    addcartdata: state.Home.Cartdata,
    addwishlistdata: state.Home.addwishlistdata,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getproductwithbrandRequest: (id) => dispatch(getproductwithbrandRequest(id)),
  getCartRequest: () => dispatch(getCartRequest()),
  insertCartRequest: (data) => dispatch(insertCartRequest(data)),
  addwishlistrequest: (data) => dispatch(addwishlistrequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Brandsproduct);
